var map = {
	"./cs.json": 82002,
	"./da.json": 1528,
	"./de.json": 12983,
	"./en-GB.json": 80052,
	"./en.json": 41825,
	"./es.json": 48908,
	"./fr-CA.json": 54212,
	"./fr.json": 787,
	"./it.json": 51595,
	"./ja.json": 33182,
	"./ko.json": 69076,
	"./nl.json": 76322,
	"./no.json": 63725,
	"./pl.json": 50696,
	"./pt-BR.json": 92688,
	"./ru.json": 47282,
	"./sv.json": 40050,
	"./zh-Hans.json": 91283,
	"./zh-Hant.json": 21617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89831;